module.exports = "<div class=\"accountFooter\">All Content Copyright {{currentYear}} All Rights Reserved</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/account-footer/account-footer.component.html
// module id = ./src/app/account-footer/account-footer.component.html
// module chunks = main